import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/core/services/token.service';
import { HasPermissionDirective } from 'src/app/directives/has-permission.directive';
import { MaterialModule } from 'src/app/material.module';
import { ConstantsService } from 'src/app/shared/services/constants.service';
import { ContactDetailListComponent } from '../contact-detail-list/contact-detail-list.component';
import { ContactDetailComponent } from '../contact-detail/contact-detail.component';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
  selector: 'app-contact-info',
  imports: [
    MaterialModule,
    TablerIconsModule,
    MatNativeDateModule,
    NgScrollbarModule,
    CommonModule,
    RouterModule,
    TranslateModule,
    MatCardModule,
    MatGridListModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    ContactDetailComponent,
    ContactDetailListComponent,
    HasPermissionDirective
  ],
  templateUrl: './contact-info.component.html',
  styleUrl: './contact-info.component.scss'
})

export class ContactInfoComponent {
  @Input() apiNameChanged: string;
  @ViewChild('contactDetailRef') contactDetailComponent!: ContactDetailComponent;
  @ViewChild('contactDetailListRef') contactDetailListComponent!: ContactDetailListComponent;
  contactInfoData: any;
  contactInfoId: number;
  currentLang: any = 'ar';
  loading: false;
  userId: number;
  langCode: string;
  data: any = {};
  amenityHasContactInfo: Boolean = false;
  showAddInfoButton: Boolean = true;
  showEditInfoButton: Boolean = false;
  showSaveInfoButton: Boolean = false;
  child2Data: any;
  navigateBackBtn: any;
  apiCallName: string;
  lookupPermissions: any

  constructor(
    private sharedService: SharedService,
    public translate: TranslateService,
    private toast: ToastrService,
    private tokenService: TokenService,
    public permissions: ConstantsService
  ) {
    let lang: any = localStorage.getItem('lang');
    let langObj: any;
    if (lang != undefined && lang != null) {

      langObj = JSON.parse(lang);
      this.langCode = langObj.code;
    }
    else {
      this.langCode = 'ar';
    }

    this.translate.use(this.langCode);
    this.userId = this.tokenService.getUserIdFromToken();

    this.lookupPermissions = this.permissions.permissions.SysLookup;
  }

  ngOnInit(): void {
    this.contactInfoData = history.state.data;
    this.apiNameChanged = this.contactInfoData.apiCallName;
    this.checkIfAmenityHasContactInfo(this.contactInfoData.apiCallName, this.contactInfoData.id);
  }

  checkIfAmenityHasContactInfo(apiCallName: string, AmenityId: number) {
    this.sharedService.getById(apiCallName, AmenityId).subscribe({
      next: (response) => {
        this.amenityHasContactInfo = (response.contactInfoId > 0);
        this.contactInfoId = response.contactInfoId;
      },
      error: (err) => {
        this.loading = false; // Stop loading
      },
      complete: () => {
        this.loading = false; // Stop loading
        if (this.amenityHasContactInfo == false) {
          // call add info
          const form: any = {
            ContactInfo: {
              nameAr: this.contactInfoData.nameAr,
              nameEn: this.contactInfoData.nameEn,
              creationUserId: this.userId,
              creationDate: new Date(),
              isActive: true,
            },
            [apiCallName]: {
              ...this.contactInfoData
            }
          }
          this.AddContactInfo(form);
        } else {
          this.contactDetailListComponent.getActiveContactDetails(this.contactInfoId);
        }
      }
    });
  }

  AddContactInfo(contactInfo: any) {
    this.sharedService.create("contact/info", contactInfo).subscribe({
      next: (response: any) => {
        this.toast.success('Contact Info added successfully!', 'Success!');
        this.contactInfoId = response.id;
      },
      error: (err) => {
        this.toast.error('Error adding Contact Info. Please try again.', 'Error!');
        this.loading = false; // Stop loading
      },
      complete: () => {
        this.amenityHasContactInfo = true;
        this.loading = false; // Stop loading
      }
    });
  }

  onAddComplete() {
    this.contactDetailListComponent.getActiveContactDetails(this.contactInfoId);
  }

  sendDetailsData(event: any) { // on update this sends the record data to contact-detail.component 
    this.child2Data = (event);
  }
}
